import { ActionTypes } from '../constants/index';

export const getCoinActivity = (payload: any) => ({
  type: ActionTypes.COIN_ACTIVITY_REQUEST,
  payload,
});
